<template>
  <div class="oauth-callback">
    <LoadingBounce></LoadingBounce>

    <b-modal id="basic-error-alert"
            class="basic-modal no-header-modal hide-cancel-btn"
            v-bind:hide-header="true"
            v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('common.modal.basic_error_alert.message')"></div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'oauth-callback',

  computed: {
    ...mapGetters([
      'currentUserLanguage',
    ]),
  },

  methods: {
    ...mapActions([
      'setToken',
      'signIn',
      'fetchUserLicence',
      'fetchPremiumSchool',
      'fetchGrades',
      'fetchSubjects',
    ]),

    getUrlParams() {
      const params = {};

      this.$route.hash.slice(1).split('&').forEach((query) => {
        const [key, value] = query.split('=');

        params[key] = value;
      });

      return params;
    },
  },

  created() {
    const urlParams = this.getUrlParams();
    const token = urlParams.access_token;
    const continueUrl = urlParams.continue_url || sessionStorage.getItem('continue_url');

    if (!token) {
      // TODO: handle error case
      console.error('no token found in URL');
      return 'something';
    }
    return this.setToken(token)
      .then(() => (
        this.signIn(token)
      ))
      .then(() => (
        Promise.all([
          this.fetchGrades(),
          this.fetchSubjects(),
          this.fetchUserLicence(),
          this.fetchPremiumSchool(),
        ])
      ))
      .then(() => {
        this.$i18n.locale = this.currentUserLanguage;
        return true;
      })
      .then(() => {
        if (continueUrl) {
          this.$router.replace(window.decodeURIComponent(continueUrl));
        } else {
          this.$router.replace('/');
        }

        return Promise.resolve();
      })
      .catch((err) => {
        console.error('err while signing in:', err);
        return Promise.reject(err);
      });
  },
};
</script>
